import { GetConsolidateRevenueData } from 'services/api/type/report.type';

const calculateTotalAvailableRooms = (data: GetConsolidateRevenueData) => {
  return Object.keys(data).reduce((sum, roomType) => {
    const availableRooms = data[roomType]?.total_available_rooms || 0;
    return sum + availableRooms;
  }, 0);
};

const createRowData = (roomType: string, data: GetConsolidateRevenueData) => {
  const roomData = data[roomType];
  const total_night = roomData?.occupied?.total_night || 0;

  return {
    key: roomType,
    roomType,
    total_night,
    occupied_percent: roomData?.occupied?.occupied_percent || 0,
    occupied_percent_total: roomData?.occupied?.occupied_percent_total || 0,
    room_price: Math.floor(roomData?.financials?.room_price || 0),
    discount: Math.floor(roomData?.financials?.discount || 0),
    service_cost: Math.floor(roomData?.financials?.service_cost || 0),
    revenue: Math.floor(roomData?.financials?.revenue || 0),
    average_price: Math.floor(roomData?.financials?.average_price || 0),
    source_id: roomData?.source_id
  };
};

const createTotalRow = (
  transformedData: any[],
  t: (key: string) => string,
  totalAvailableRooms: number
) => {
  const totals = transformedData.reduce(
    (acc, row) => ({
      total_night: acc.total_night + row.total_night,
      occupied_percent: acc.occupied_percent + row.occupied_percent,
      occupied_percent_total: acc.occupied_percent_total + row.occupied_percent_total,
      room_price: acc.room_price + row.room_price,
      discount: acc.discount + row.discount,
      service_cost: acc.service_cost + row.service_cost,
      revenue: acc.revenue + row.revenue
    }),
    {
      total_night: 0,
      occupied_percent: 0,
      occupied_percent_total: 0,
      room_price: 0,
      service_cost: 0,
      discount: 0,
      revenue: 0
    }
  );

  const average_price =
    totals.total_night > 0 ? Math.floor(totals.room_price / totals.total_night) : 0;

  const occupied_percent =
    totalAvailableRooms > 0
      ? parseFloat(((totals.total_night / totalAvailableRooms) * 100).toFixed(2))
      : 0;

  return {
    key: t('common.total'),
    roomType: t('common.total'),
    total_night: totals.total_night,
    occupied_percent,
    occupied_percent_total: parseFloat(totals.occupied_percent_total.toFixed(2)),
    room_price: totals.room_price,
    discount: totals.discount,
    service_cost: totals.service_cost,
    revenue: totals.revenue,
    average_price
  };
};

export const transformDataToTable = (
  data: GetConsolidateRevenueData,
  t: (key: string) => string
) => {
  if (Array.isArray(data) || !data) return [];

  const totalAvailableRooms = calculateTotalAvailableRooms(data);

  const transformedData = Object.keys(data)
    .filter(roomType => (data[roomType]?.occupied?.total_night || 0) > 0)
    .map(roomType => createRowData(roomType, data));

  if (transformedData.length === 0) return [];

  const totalRow = createTotalRow(transformedData, t, totalAvailableRooms);

  return [...transformedData, totalRow];
};
